module.exports = __webpack_public_path__ + "fonts/ChuangKeTieJinGangTi-2.af85fa95.otf";